import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { salesTemplate } from '../../tools/callWindowTemplates';
import { actionOneButtonStyle, actionTwoButtonStyle } from '../../theme';
import { Box, Typography } from '@mui/material';

const TemplateDialog = ({ open, onClose, callWindows, setCallWindows }) => {
    const [selectedTemplate, setSelectedTemplate] = useState('');

    const handleTemplateChange = (event) => {
        setSelectedTemplate(event.target.value);
    };

    const handleConfirm = () => {
        switch (selectedTemplate) {
            case 'sales':
                setCallWindows([...callWindows, ...salesTemplate.callWindows]);
                break;
            // Add cases for other templates as needed
            default:
                break;
        }
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Call Window Template</DialogTitle>
            <DialogContent>
                <Box display="flex" flexDirection="column" gap={2}>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel>Call Window Template</InputLabel>
                        <Select
                            value={selectedTemplate}
                            onChange={handleTemplateChange}
                            label="Call Window Template"
                        >
                            <MenuItem value="">None</MenuItem>
                            <MenuItem value="sales">Sales/SOL</MenuItem>
                            {/* <MenuItem value="debt">Debt Collection</MenuItem>
                        <MenuItem value="ebr">EBR</MenuItem> */}
                        </Select>
                    </FormControl>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                        For most accurate results, contact data should include zip code data.
                    </Typography>
                    <Typography variant="body2" color="textSecondary" sx={{ mt: 2 }}>
                        These templates are provided as convenience and should be reviewed to ensure they meet your specific needs before applying. We cannot guarantee that these templates will be compliant with all applicable laws and regulations, as these can vary widely by jurisdiction and may change over time. It is your responsibility to review the provided call windows.
                    </Typography>
                </Box>
            </DialogContent>
            {selectedTemplate && (
                <DialogActions>
                    <Button sx={actionTwoButtonStyle} onClick={() => setSelectedTemplate('')}>Cancel</Button>
                    <Button
                        sx={actionOneButtonStyle}
                        onClick={handleConfirm}
                        variant="contained"
                        disabled={!selectedTemplate}
                    >
                        Apply Template
                    </Button>
                </DialogActions>)}
            {!selectedTemplate && (
                <DialogActions>
                    <Button sx={actionTwoButtonStyle} onClick={onClose} variant="contained">Close</Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default TemplateDialog;